import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "APPOINTMENTS",
    applicationRights: Rights,
    title: 'Frav&aelig;r',
    text: 'Frav&aelig;r',
    icon: 'calendar',
    showOnDashboardByDefault: false,
    url: "/appointments",
    sequenceNo: 5000,
    routes: Routes
})
